<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
        title="深情感文"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :offset="offset"
              :immediate-check="ischeck"
              @load="loadMore"
            >
          <div is-link center v-for="(item,index) in articleList" :key="index" >
              <router-link class="article-list van-hairline--bottom" :to="{path:'/MemoryDetails?id=' + item.SerialNumber + '&memorialArticleID=' + item.MemorialArticleID + '&MemorialHallID=' + item.MemorialHallID}">
                <div class="hd">
                  <div class="image">
                    <van-image
                      radius="3"
                      fit="cover"
                      v-bind:src="item.CoverPhoto"
                    />
                  </div>
                </div>
                <div class="bd">
                  <h2 class="title">{{item.Title}}</h2>
                  <p class="des van-multi-ellipsis--l3">  {{item.Content}}</p>
                </div>
                <p class="date">{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>
              </router-link>
          </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <router-link class="article-list van-hairline--bottom" to="/MemoryDetails" v-for="item in 3" :key="item.id">
        <div class="hd">
          <div class="image">
            <van-image
              radius="3"
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
        </div>
        <div class="bd">
          <h2 class="title">一首歌的事</h2>
          <p class="des van-multi-ellipsis--l3">  《心火》是姚贝娜演唱的一首歌曲，由崔迪谱曲、文雅填词，收录专辑中。该曲以自白式的歌词描写出姚贝娜对于过去的不屈</p>
        </div>
        <p class="date">2020-02-19</p>
      </router-link>
    </div> -->
  </div>
</template>

<script>
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: false,
        finished: false,
        offset: 100,
        ischeck: false,
        isLogin: false,
        options: null,
        articleList : [],
	    };
	  },
	  components: {
    },
    created(){
      this.init();
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
    },
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
    methods: {
      init(){
        var _this = this;
        _this.options = {
          type: "getMemorialArticleList",
          pageIndex: 1
        };
        _this.getMemorialArticleList();
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      onRefresh() {
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1
        });
        this.getMemorialArticleList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1
        });
        this.loading = true;
        this.getMemorialArticleList();
      },
      getMemorialArticleList(){
        var _this = this;
        this.$store
          .dispatch(_this.options)
          .then(result => {
            _this.loading = false;
            if (_this.refreshing) {
              _this.refreshing = false;
            }

            var dataList = result.DeepArticleApiModelList;

             if(dataList == null || dataList.length == 0){
              _this.finished = true;
              return;
            }

            if(_this.options.pageIndex > 1){
              for (let i = 0; i < dataList.length; i++) {
                _this.articleList.push(
                  dataList[i]
                );
              }
            }else{
              _this.articleList = result.DeepArticleApiModelList;
            }

            if (dataList.length < 10) {
                _this.finished = true;
            }
        });
      }
    }
	};
</script>

<style scoped>
.article-list{
  padding: 15px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.article-list>.hd{
  width: 90px;
  height: 90px;
  margin-right: 12px;
}
.article-list>.bd{
  flex: 1;
  overflow: hidden;
  position: relative;
}
.article-list>.bd>.title{
  font-weight: normal;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #555;
}
.article-list>.date{
  font-size: 12px;
  color: #bbb;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  bottom: 10px;
  right: 15px;
}
.article-list>.bd>.des{
  font-size: 12px;
  color: #777;
  margin-top: 3px;
  line-height: 1.45
}
</style>
